import { ICommand, IDefineCommand, IQueryMediator } from 'core-ts-types';
import { ITransferCIPProgramAreasDatasource } from './../datasources/transfer_cip_program_areas_datasource';

angular
  .module('capability-ng-transfer')
  .factory(
    'loadTransferCIPProgramAreasCommand',
    (defineCommand: IDefineCommand, $http: ng.IHttpService, QueryMediator: IQueryMediator, ngTransferCIPProgramAreasDatasource: ITransferCIPProgramAreasDatasource): ICommand => {
      return defineCommand('loadTransferCIPProgramAreasCommand', (deferred: ng.IDeferred<any>): ng.IPromise<void> => {
        return $http({
          method: 'GET',
          url: 'reference/cip-program-area/'
        })
          .then((response: ng.IHttpPromiseCallbackArg<any>): void => {
            ngTransferCIPProgramAreasDatasource.write(response.data.results);

            deferred.resolve(QueryMediator.runQueries(ngTransferCIPProgramAreasDatasource));
          })
          .catch(deferred.reject);
      });
    }
  );



// WEBPACK FOOTER //
// ./app/lib/transfer/commands/load_transfer_cip_program_areas_command.ts